import { Trans } from "@lingui/macro";
import { UiModuleLoader } from "@smp/ui";
import { lazy, Suspense } from "react";

const Module = lazy(() => import(/* webpackChunkName: "shared" */ "./shared"));

export const Shared = () => (
  <Suspense fallback={<UiModuleLoader loadingText={<Trans>Loading</Trans>} />}>
    <Module />
  </Suspense>
);
